module.exports = __webpack_public_path__ + "img/Marketing target Icon - white.4ee79023.svg";